import type React from 'react'
import type { IconProps } from './types'

const Dropdown: React.FC<IconProps> = ({ size = 20, className = 'fill-neutral-900' }) => (
	<svg
		width={size}
		height={size}
		viewBox='0 0 24 24'
		className={className}
		fill='currentColor'
		xmlns='http://www.w3.org/2000/svg'
		aria-hidden='true'>
		<path d='M12 15L7 10H17L12 15Z' />
	</svg>
)

export default Dropdown
